/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useState, useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import useFormValidator from 'useFormValidator';
import * as actions from '../actions';
import * as c from '../constants';

function ManualPaymentModal({
  transactionInfo,
  transactionId,
  manualPaymentApprove,
  manualPaymentReject,
  approving,
  rejecting,
  onClear,
}) {
  const setModal = useContext(ModalContext);
  const [showRemarks, setShowRemarks] = useState(false);

  const [formData, setFormData] = useState({
    manual_posting_paid_at: '',
    manual_posting_reference_no: '',
    manual_posting_reference_url: '',
    remarks: ''
  });

  const validateForm = useFormValidator(formData, {
    manual_posting_paid_at: 'required',
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const args = {
      manual_posting_paid_at: _.get(formData, 'manual_posting_paid_at'),
      manual_posting_reference_no: _.get(
        formData,
        'manual_posting_reference_no'
      ),
      manual_posting_reference_url: _.get(
        formData,
        'manual_posting_reference_url'
      )
        ? _.get(formData, 'manual_posting_reference_url')
        : _.get(formData, 'payment_receipt_url'),
    };

    manualPaymentApprove(transactionId, args, () => {
      onClear(e);
      setModal({ isOpen: false });
    });
  };

  const handleReject = (e) => {
    e.preventDefault();

    const args = {
      remarks: _.get(formData, 'remarks'),
    };

    manualPaymentReject(transactionId, args, () => {
      onClear(e);
      setModal({ isOpen: false });
    });
  };

  const remarks = _.get(transactionInfo, 'payment_receipt_url_remarks') || '';

  const approved = _.get(transactionInfo, 'is_approved_payment_receipt') || '';

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChangeDate = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.target.value : '',
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onChangePhoto = (key) => (value) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      manual_posting_reference_url: _.get(
        formData,
        'manual_posting_reference_url'
      ),
    });
  }, [_.get(formData, 'manual_posting_reference_url')]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const getImageFormat = (url) => {
    if (typeof url !== 'string') return null;
    return url.split('.').pop().toLowerCase();
  };

  const imageFormat = getImageFormat(_.get(formData, 'manual_posting_reference_url') || _.get(transactionInfo, 'payment_receipt_url'));

  const applicationDate = moment(_.get(transactionInfo, 'created_at')).format('MM/DD/YYYY') || '';

  const today = new Date();
  const maxWorkingDate = new Date(today);

  const dayOfWeek = today.getDay();

  if (dayOfWeek === 5) {
    // if today is friday, set maxWorkingDate to monday
    maxWorkingDate.setDate(today.getDate() + 3);
  } else {
    // add 1 working day
    maxWorkingDate.setDate(today.getDate() + 1);
  }

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12">
          {approved && (
            <div className="alert alert-success" role="alert">
              {remarks}
            </div>
          )}
          {!approved && remarks && (
            <div className="alert alert-danger" role="alert">
              {remarks}
            </div>
          )}
          {!remarks && 
            !_.get(formData, 'manual_posting_reference_url') &&
            !_.get(transactionInfo, 'payment_receipt_url') && (
              <div className="alert alert-info" role="alert">
                No uploaded receipt
              </div>
            )
          }
        </div>

        <div className="col-12 form-group">
          <label
            htmlFor="manual_posting_reference_url"
            className="form-label mb-1"
          >
            Upload Photo {validateForm.renderMessage('manual_posting_reference_url')}
          </label>
        </div>
        <div className='col-12 form-group text-center'>
          {imageFormat === 'pdf' ? (
            <iframe
              src={
                _.get(formData, 'manual_posting_reference_url')
                ? _.get(formData, 'manual_posting_reference_url')
                : _.get(transactionInfo, 'payment_receipt_url') ||
                  ImagePlaceholder
              }
              title="Payment Receipt"
              style={{ width: '100%', height: 600, border: 'none' }}
            />
          ) : (
            <img
              src={
                _.get(formData, 'manual_posting_reference_url')
                ? _.get(formData, 'manual_posting_reference_url')
                : _.get(transactionInfo, 'payment_receipt_url') ||
                  ImagePlaceholder
              }
              alt="Preview"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          )}
        </div>
        <div className="col-12 form-group">
          <FilePondSingleUpload
            onChange={onChangePhoto('manual_posting_reference_url')}
          />
        </div>
        {!approved && !showRemarks && (
          <>
            <div className="col-12 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                Payment Date {validateForm.renderMessage('manual_posting_paid_at')}
              </label>
              <DateInputPicker
                className="form-control"
                minDate={new Date(applicationDate)}
                maxDate={maxWorkingDate}
                onChange={onChangeDate('manual_posting_paid_at')}
                value={_.get(formData, 'manual_posting_paid_at') || ''}
              />
            </div>
            <div className="col-12 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                Reference Number{' '}
              </label>
              <input
                className="form-control"
                type="text"
                name="manual_posting_reference_no"
                onChange={onChange}
                value={_.get(formData, 'manual_posting_reference_no') || ''}
              />
            </div>
          </>
        )}
      </div>
      {!_.get(transactionInfo, 'is_approved_payment_receipt') && (
        <form onSubmit={handleSubmit} className="pt-2">
          {showRemarks && (
            <div className="row">
              <div className="col-12 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Remarks
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="remarks"
                  onChange={onChange}
                  value={_.get(formData, 'remarks') || ''}
                />
              </div>
            </div>
          )}
          <div className="row d-flex justify-content-center pt-2">
            {showRemarks ? (
              <div>
                <button
                  type="button"
                  className="btn btn-danger mr-1"
                  onClick={handleReject}
                  disabled={rejecting}
                >
                  Reject
                </button>
                <button
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowRemarks(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            ) : (
              <div>
                <button
                  type="submit"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-1"
                  disabled={approving || !validateForm.response.is_passed}
                >
                  Approve
                </button>
                <button
                  type="button"
                  className="btn btn-danger mr-1"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowRemarks(true);
                  }}
                  disabled={rejecting}
                >
                  Reject
                </button>
                <button
                  type="button"
                  onClick={closeModal}
                  className="btn btn-dark"
                >
                  <span className="font-weight-bold">Close</span>
                </button>
              </div>
            )}
          </div>
        </form>
      )}
    </Modal.Body>
  );
}

ManualPaymentModal.propTypes = {
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  transactionId: PropTypes.string.isRequired,
  manualPaymentApprove: PropTypes.instanceOf(Function).isRequired,
  manualPaymentReject: PropTypes.instanceOf(Function).isRequired,
  approving: PropTypes.bool.isRequired,
  rejecting: PropTypes.bool.isRequired,
  onClear: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  approving: api.loading.indexOf(c.MANUAL_PAYMENT_APPROVE) > -1,
  rejecting: api.loading.indexOf(c.MANUAL_PAYMENT_REJECT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ManualPaymentModal);
